import { useEffect, useState } from "react";
import formatStorage from "project-config/utils/format-storage";
import { useQuery } from "react-query";

interface IStorageInfo {
  expiredDate: number;
  freeCapacity: number;
  usedCapacity: number;
}

interface CapacityInfo {
  storage: number;
  unit: string;
  origin: number;
}

export function useCapacityInfo() {
  const { data } = useQuery<IStorageInfo>(
    "/api/rendering/task/transfer/getUserStorageInfo"
  );
  const [freeCapacity, setFreeCapacity] = useState<CapacityInfo>();
  const [usedCapacity, setUsedCapacity] = useState<CapacityInfo>();
  const [capacityRate, setCapacityRate] = useState(0);
  useEffect(() => {
    if (!data) return;

    setFreeCapacity(formatStorage(data.freeCapacity || 0));
    setUsedCapacity(formatStorage(data.usedCapacity || 0));

    let freeCapacity = data.freeCapacity || 0;
    if (!freeCapacity) {
      return;
    }
    let usedCapacity = data.usedCapacity || 0;
    const rate = Number(((usedCapacity * 100) / freeCapacity).toFixed(2));
    setCapacityRate(rate);
  }, [data]);

  return { freeCapacity, usedCapacity, capacityRate };
}
